// Change to selected page form in contact child page

let contactFormSelect = document.querySelector('.form-select__input');

if(document.body.contains(contactFormSelect)){
    contactFormSelect.addEventListener('change', function(e){
        let selectedOption = contactFormSelect.options[contactFormSelect.selectedIndex],
            redirection = selectedOption.dataset.redir;

            window.location.href = redirection;
    });

    // To rotate the chevron
    contactFormSelect.addEventListener('click', function(e){
        contactFormSelect.parentNode.classList.toggle('select-open');
    });
}